import Vue from 'vue'

import VanToast from 'vant/lib/toast'
import VantPopup from 'vant/lib/popup'
import vanOverlay from 'vant/lib/overlay'
import VantLazyLoad from 'vant/lib/lazyload'
import Swipe from 'vant/lib/swipe'
import SwipeItem from 'vant/lib/swipe-item'
import vanButton from 'vant/lib/button'
import Lazyload from 'vant/lib/lazyload'
import Tabs from 'vant/lib/tabs'
import Tab from 'vant/lib/tab'
import Image from 'vant/lib/image'
import Icon from 'vant/lib/icon'
import Field from 'vant/lib/field'
import List from 'vant/lib/list'
import Collapse from 'vant/lib/collapse';
import CollapseItem from 'vant/lib/collapse-item';

import 'vant/lib/lazyload/style'
import 'vant/lib/popup/style'
import 'vant/lib/overlay/style'
import 'vant/lib/button/style'
import 'vant/lib/toast/style'
import 'vant/lib/swipe/style'
import 'vant/lib/swipe-item/style'
import 'vant/lib/lazyload/style'
import 'vant/lib/tabs/style'
import 'vant/lib/tab/style'
import 'vant/lib/image/style'
import 'vant/lib/icon/style'
import 'vant/lib/field/style'
import 'vant/lib/list/style'
import 'vant/lib/collapse/style'
import 'vant/lib/collapse-item/style'


Vue.use(List)
Vue.use(VantPopup)
Vue.use(vanOverlay)
Vue.use(VantLazyLoad)
Vue.use(vanButton)
Vue.use(VanToast)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Lazyload)
Vue.use(Tabs)
Vue.use(Tab)
Vue.use(Image)
Vue.use(Icon)
Vue.use(Field)
Vue.use(Collapse)
Vue.use(CollapseItem)

export const Toast = VanToast
